import SearchResults from './pages/SearchResults';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DetailPage from './pages/DetailPage';
import Layout from './components/Layout';
import Home from './pages/Home';
import SearchFieldProvider from './SearchFieldProvider';
import ActiveSlideProvider from './ActiveSlideProvider';
import Form from './components/Form';
import 'mapbox-gl/dist/mapbox-gl.css';
import axios from 'axios';
import { useState, useEffect } from 'react';
import MobileSearchResults from './pages/mobile/MobileSearchResults';
import MobileDetailPage from './pages/mobile/MobileDetailPage';
import MobileHome from './pages/mobile/MobileHome';
import MobileAbout from './pages/mobile/MobileAbout';
import MobileEventList from './components/mobile/MobileEventList';

function App() {
  const [events, setEvents] = useState([]);

  const url = "https://a-list-backend.onrender.com/events/";

  useEffect(() => {
    async function getEvents() {
      await axios.get(url)
      .then((response) => setEvents(response.data.sort((a, b) => a.start_time.localeCompare(b.start_time))));
    }
    getEvents();
    //eslint-disable-next-line
    }, []);

  useEffect(() => {
    if (events.length > 0) {
      localStorage.setItem("events", JSON.stringify(events));
    }
  }, [events])

  if (!events) {
    setEvents(JSON.parse(localStorage.getItem("events")));
  }

  console.log(events);

  if (window.innerWidth < 700) {
    return (
      <BrowserRouter>
        <SearchFieldProvider>
          <ActiveSlideProvider>
          <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<MobileHome events={events}/>}/>
                <Route path="about" element={<MobileAbout />}/>
                <Route path="searchResults" element={<MobileSearchResults events={events}/>}/>
                <Route path="form" element={<Form />} />
                {events.map(event => (
                  <Route 
                    key={event.id} 
                    path={`/event/${event.id}`} 
                    element={<MobileDetailPage event={event} />} 
                  />
                ))}
              </Route>
              <Route path="mobile" element={<MobileEventList events={events}/>}/>
          </Routes>
          </ActiveSlideProvider>
        </SearchFieldProvider>
      </BrowserRouter>
    )
  } else {
    return (
      <BrowserRouter>
        <SearchFieldProvider>
          <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />}/>
                <Route path="searchResults" element={<SearchResults events={events}/>} />
                <Route path="form" element={<Form />} />
                {events.map(event => (
                  <Route 
                    key={event.id} 
                    path={`/event/${event.id}`} 
                    element={<DetailPage event={event} />} 
                  />
                ))}
              </Route>
          </Routes>
        </SearchFieldProvider>
      </BrowserRouter>
  );

  }

  
}

export default App;
